import React, { useState } from 'react';
import { connect } from 'react-redux';
import { forgotPassword } from '../../redux';
import ForgotPasswordForm from './ForgotPasswordForm';

function ForgotPasswordFormContainer (props) {
    const [state, setState] = useState({
        email: '',
        message: '',
    });

    const handleChange = (e) => {
        setState({...state, [e.target.name]: e.target.value});
    }

    const submissionSuccess = () => {
        setState({
            ...state,
            email: '',
            message: 'The link has been sent to your email. Make sure to also check your spam folder.'
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.forgotPassword(state.email);
        submissionSuccess();
    }

    let authErrCode = props.authErrCode.forgotPassword;
    let errMsg = state.message;
    if (authErrCode < 500 && authErrCode > 399) {
        errMsg = "Invalid email!";
    } else if (authErrCode > 499) {
        errMsg = "Server error!";
    }

    return (
        <ForgotPasswordForm
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            errMsg={errMsg}
            {...state}
        />
    )
}

export default connect(state => state.root, { forgotPassword })(ForgotPasswordFormContainer);
